import React from 'react';

const EyeIcon = () => {
    return (
        <svg className="svg-inline" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.5 9.30469C8.19036 9.30469 8.75 8.74504 8.75 8.05469C8.75 7.36433 8.19036 6.80469 7.5 6.80469C6.80964 6.80469 6.25 7.36433 6.25 8.05469C6.25 8.74504 6.80964 9.30469 7.5 9.30469Z"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.75 8.05469C12.0831 10.9716 10 12.4297 7.5 12.4297C5 12.4297 2.91688 10.9716 1.25 8.05469C2.91688 5.13781 5 3.67969 7.5 3.67969C10 3.67969 12.0831 5.13781 13.75 8.05469Z"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default EyeIcon;
